import React, { useState, useEffect } from "react";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Avatar from "@mui/material/Avatar";
import { Grid } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

// import { userLogs } from "../../Js/Common";

const Profile = (props) => {
  // Hooks
  const dispatch = useDispatch();
  const navigation = useNavigate();

  // State
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  // Redux state
  const { userInfo, userPermission } = useSelector((state) => state.loggedInUserInfo);

  console.log("userPermission", userPermission);
  // Logout logic
  const logout = async () => {
    localStorage.removeItem("feathers-jwt");
    let logObj = {
      actor: userInfo.uid,
      site_uuid: userInfo.site_uuid,
      verb: "logout",
      target: null,
      context: null,
      outcome: null,
    };
    // await userLogs(logObj);  
    if (document.fullscreenElement) {
      document
        .exitFullscreen()
        .then(() => console.log("Document Exited from Full screen mode"))
        .catch((err) => console.error(err));
    }
    setTimeout(() => {
      dispatch({ type: "RESET_APP" });    
    }, 500);
    navigation("/");
  };
  
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const checkPermission = (permissionName) => {
    return (userPermission.indexOf(permissionName) > -1);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  
  return (
    <div>
      <Button aria-describedby={id} onClick={handleClick}>
        <Avatar
          sx={{
            bgcolor: "primary.main",
            "@media (min-width: 1636px)": {
              fontSize: "1.4rem",
              height: "3rem",
              width: "3rem",
            },
          }}
        >
          {userInfo !== undefined &&
            userInfo !== null &&
            (userInfo.uname.firstname
              ? userInfo.uname.firstname.toUpperCase()[0]
              : "") +
              "" +
              (userInfo.uname.lastname
                ? userInfo.uname.lastname.toUpperCase()[0]
                : "")}
        </Avatar>
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        sx={{ textAlign: "center" }}
        PaperProps={{ style: { borderRadius: "35px" } }}
      >
        
          <Grid sx={{ py: 2, px: 3 }}>
            <Grid sx={{ px: 1, py: 2 }}>
              <Typography
                fontSize={"1.3rem"}
                sx={{
                  color: "primary.main",
                  "@media (min-width: 1636px)": {
                    fontSize: "1.6rem",
                  },
                }}
              >
                <span className="textbold">
                  {userInfo !== undefined &&
                    userInfo !== null &&
                    userInfo.uname.firstname + " " + userInfo.uname.lastname}
                </span>
              </Typography>
              <Typography
                fontSize={"0.8rem"}
                sx={{
                  color: "primary.subhead",
                  "@media (min-width: 1636px)": {
                    fontSize: "1.4rem",
                  },
                }}
              >
                <span>
                  {userInfo !== undefined &&
                    userInfo !== null &&
                    userInfo.rolesInfo &&
                    userInfo.rolesInfo.title}
                </span>
              </Typography>
            </Grid>
            {checkPermission("viewProfile") ?
            <Grid>
              <Button
                variant="outline"
                color="success"
                sx={{
                  borderRadius: 10,
                  border: 1,
                  mt: "4px",
                  color: "primary.main",
                  fontWeight: "bold",
                  "@media (min-width: 1636px)": {
                    fontSize: "1rem",
                  },
                }}
                onClick={() => {
                  navigation("/Profile");
                  setAnchorEl(null);
                }}
              >
                Manage your profile
              </Button>
            </Grid>
             : null} 
            {userInfo?.employeeProfile && <Grid>
              <Button
                variant="outline"
                color="success"
                sx={{
                  borderRadius: 10,
                  border: 1,
                  mt: "4px",
                  color: "primary.main",
                  fontWeight: "bold",
                  "@media (min-width: 1636px)": {
                    fontSize: "1rem",
                  },
                }}
                onClick={() => {
                  navigation("/EmployeeProfile");
                  setAnchorEl(null);
                }}
              >
                View Profile
              </Button>
            </Grid>}
            <Grid>
              <Button
                id="LOGOUT"
                onClick={logout}
                variant="contained"
                fullWidth
                sx={{
                  borderRadius: 10,
                  border: 1,
                  backgroundColor: "primary.main",
                  color: "#FFF",
                  fontWeight: "bold",
                  mt: 3,
                  "@media (min-width: 1636px)": {
                    fontSize: "1rem",
                  },
                }}
              >
                LOGOUT
              </Button>
            </Grid>
          </Grid>
        
      </Popover>
    </div>
  );
};

export default Profile;
